import { apiClient } from './client'

interface GoogleTimeZoneResponse {
  status: string
  timeZoneId?: string
}

export type TimeZoneSuccess = {
  found: true
  timeZoneId: string
}

export type TimeZoneFailure = {
  found: false
  code: string
}

export type TimeZoneResult = TimeZoneSuccess | TimeZoneFailure

const TimeZone = async (lat: number, lng: number): Promise<TimeZoneResult> => {
  const res = await apiClient<GoogleTimeZoneResponse>(
    `/google/timezone?lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`,
    {},
  )
  if (res.status === 'OK') {
    return {
      found: true,
      timeZoneId: res.timeZoneId || 'Google should have put Zone ID here',
    }
  } else {
    return {
      found: false,
      code: res.status,
    }
  }
}

export default TimeZone
